import { Component, OnInit, OnDestroy } from "@angular/core";
import { Notification } from "../admin.interface";
import { DashboardService } from "./dashboard.service";
import { NotificationService } from "../../common/notification/notification.service";
import { Router } from "@angular/router";
import "rxjs/add/operator/takeWhile";
import { ConfigService } from "../../utils/services/config.service";
import { ApplicationConfig } from "../../utils/models/config";
import { SessionStorage } from "ngx-webstorage";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit, OnDestroy {
  @SessionStorage() public user;
  @SessionStorage() public config;

  public notification: Notification[] = []; // A Array of object to display the notfication obtained
  public pageNumber = 1; // A variable for the pagination defaulted to value 1
  public empCount = 0; // Vaiable to show the total Employee in the organisation
  public projectCount = 0; // Variable toshow the total projects
  public auditlog: Array<any> = []; // An Array of objec with different logs of actions happening in the system
  public locksheetCount = 0;
  public nonComplianceLockedCount = 0; // Total count of the locked timesheet
  private alive: boolean = true; // A variable to unsubscribe the observable service call from Memory leak
  public totalHeadCountCDMO = 0;
  public totalHeadCountAPSL=0;
  public totalHeadCountDiscovery=0;
  public totalEmployeeCount=0;
  constructor(
    public dashboardService: DashboardService,
    public router: Router,
    public notificationService: NotificationService,
    private configService: ConfigService,
    private spinnerService: Ng4LoadingSpinnerService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.getNotificationList();
    this.getDashBoardDetails();
    //this.getConfigSettings();
    }

  /**
   * @function getDashBoardDetails
   * @description
   * getDashBoardDetails is the function to get all the Count of employee, project, locked timesheet along
   * with the audit logs details for the particular logged admin user
   * @var empCount variable to store the total employee count obtained from the Backend upon API call
   * @var projectCount variable to store the total project count obtained from the Backend upon API call
   * @var locksheetCount variable to store the total locked timesheet count obtained from the Backend upon API call
   * @var auditlog variable to store the total audit logs obtained from the Backend upon API call
   * @method get
   * @requires takeWhile An rxjs operator to subscribe the service
   * @author gaurav.rao
   **/

  getDashBoardDetails() {
    this.spinnerService.show();
    this.dashboardService
      .getDashboardDeatils()
      .takeWhile(() => this.alive)
      .subscribe(
        (data) => {
          console.log(JSON.stringify(data.payload));
          this.spinnerService.hide();
          this.empCount = data.payload.empcount;
          this.projectCount = data.payload.projectcount;
          this.locksheetCount = data.payload.lockedtimesheetCount;
          this.nonComplianceLockedCount = data.payload.nonComplianceLockedCount
            ? data.payload.nonComplianceLockedCount
            : 0;
            this.totalEmployeeCount=data.payload.totalempcount?data.payload.totalempcount:0;
          this.auditlog = data.payload.auditlogData;
          this.totalHeadCountAPSL=data.payload.totalHeadCount?data.payload.totalHeadCount:0;
          if (this.auditlog.length > 3) {
            this.auditlog.length = 3; // Limit the audit log data to 3 elements in HTML view
          }
        },
        (error) => {
          this.spinnerService.hide();
        }
      );
  }

  /**
   * @function getNotificationList
   * @description
   * getNotificationList is the function to get all the notification obtained for the particular logged user
   * and display it in the table format for the end user.
   * @var notification variable to store the list obtained from the Backend upon API call
   * @method post
   * @argument pageNumber current page number choosen by the end user (Default set to 1)
   * @requires takeWhile An rxjs operator to subscribe the service
   * @author gaurav.rao
   **/

  getNotificationList() {
    this.notificationService
      .getNotification(this.pageNumber)
      .takeWhile(() => this.alive)
      .subscribe(
        (data) => {
          if (data.payload.notifications) {
            data.payload.notifications.map((value) =>
              this.notification.push(new Notification(value))
            );
            if (this.notification.length > 3) {
              this.notification.length = 3; // Set the length for Array you want to display
            }
          }
        },
        (error) => {
          this.notification.length = 0;
        }
      );
  }

  // getConfigSettings() {
  //   this.spinnerService.show();
  //   this.dashboardService
  //     .getGlobalSettingsCDMO()
  //     .takeWhile(() => this.alive)
  //     .subscribe(
  //       (data) => {
  //         console.log( data.payload);
  //         this.totalHeadCountCDMO = data.payload.totalHeadCount;

  //       },
  //       (error) => {
  //         this.spinnerService.hide();
  //       }
  //     );

  //     this.dashboardService
  //     .getGlobalSettingsAPSL()
  //     .takeWhile(() => this.alive)
  //     .subscribe(
  //       (data) => {
  //         console.log( data.payload);
  //         this.totalHeadCountAPSL = data.payload.totalHeadCount;

  //       },
  //       (error) => {
  //         this.spinnerService.hide();
  //       }
  //     );

  //     this.dashboardService
  //     .getGlobalSettingsDiscovery()
  //     .takeWhile(() => this.alive)
  //     .subscribe(
  //       (data) => {
  //         console.log( data.payload);
  //         this.totalHeadCountDiscovery = data.payload.totalHeadCount;

  //       },
  //       (error) => {
  //         this.spinnerService.hide();
  //       }
  //     );

  // }

  // updateTotalHeadCountAPSL() {
  //   const data = {
  //     totalHeadCount : this.totalHeadCountAPSL,
  //     businessUnit : "total"
  //   };
  //   this.dashboardService.updateHeadCount(data).subscribe(
  //     (response) => {
  //       this.spinnerService.hide();
  //       this.snackBar.open("Total Head Count For APSL Updated Successfully", "Okay", {
  //         duration: 3000,
  //       });

  //     },
  //     (err) => {
  //       if (err) {
  //         this.snackBar.open(err.error.message, "Okay", {
  //           duration: 3000,
  //         });
  //       }
  //       this.spinnerService.hide();
  //     }
  //   );
  // }

  // updateTotalHeadCountDiscovery() {
  //   const data = {
  //     totalHeadCount : this.totalHeadCountDiscovery,
  //     businessUnit : "discovery"
  //   };
  //   this.dashboardService.updateHeadCount(data).subscribe(
  //     (response) => {
  //       this.spinnerService.hide();
  //       this.snackBar.open("Total Head Count For Discovery Updated Successfully", "Okay", {
  //         duration: 3000,
  //       });

  //     },
  //     (err) => {
  //       if (err) {
  //         this.snackBar.open(err.error.message, "Okay", {
  //           duration: 3000,
  //         });
  //       }
  //       this.spinnerService.hide();
  //     }
  //   );
  // }
  /* add Employee */
  updateTotalHeadCountCDMO() {
    const data = {
      totalHeadCount : this.totalHeadCountCDMO,
      businessUnit :"cdmo"
    };
    this.dashboardService.updateHeadCount(data).subscribe(
      (response) => {
        this.spinnerService.hide();
        this.snackBar.open("Total Head Count For CDMO Updated Successfully", "Okay", {
          duration: 3000,
        });

      },
      (err) => {
        if (err) {
          this.snackBar.open(err.error.message, "Okay", {
            duration: 3000,
          });
        }
        this.spinnerService.hide();
      }
    );
  }





  /*
   * Navigate the Admin to Project page upon click event
   * @author Abhiraj SN
   */
  navigateToProject() {
    this.router.navigate(["/admin/project"]);
  }

  /*
   * Navigate the Admin to Employee page upon click event
   * @author Abhiraj SN
   */
  navigateToEmployees() {
    this.router.navigate(["/admin/employees"]
    // , {
    //   queryParams: { status: "active" },
    // }
    );
  }

  /*
   * Navigate the Admin to Locked Timesheet page upon click event
   */
  navigateTolockedTimesheet() {
    this.router.navigate(["/admin/locked-timesheet"]);
  }

  /*
   * Navigate the Admin to Compliance Locked Timesheet page upon click event
   * @author Abhiraj SN
   */
  navigateToCompliancelockedTimesheet() {
    this.router.navigate(["/admin/locked-list"]);
  }
  navigateToTotalEmployees()
  {
    this.router.navigate(["/admin/employees/"],{queryParams: { totalemployees: 'true' }});
  }

  /**
   * @function ngOnDestroy()
   * @description
   * Function to destroy the Subscription used while calling API
   * Unsubscribe the observable is done using takeUntil method of rxjs
   * @author gaurav.rao
   */
  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/dashboard/dashboard.component.ts